import React, { useState } from "react";
import { Collapse, FormGroup, Label, CustomInput } from "reactstrap";
import { useTranslation } from "react-i18next";

import ReleaseStoreCheckboxItem from "./releaseStoreCheckboxItem";

const getUniqueStores = (stores) => {
  const seen = new Set();

  return stores.filter((store) => {
    if (seen.has(store.id)) {
      return false;
    }

    seen.add(store.id);
    return true;
  });
};

const ReleaseStoreSection = ({
  title,
  stores,
  selectedStores,
  setSelectedStores,
  readOnly = false,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  const isStoreSelected = (store) => selectedStores.some((selectedStore) => selectedStore.id === store.id);
  const selectableStores = stores.filter((store) => !store.disabledReason);
  const areAllStoresSelected = selectableStores.length > 0 && selectableStores.every((store) => isStoreSelected(store));
  const selectedVisibleCount = stores.filter((store) => isStoreSelected(store)).length;

  const handleChange = (isChecked, store) => {
    if (readOnly || store.disabledReason) {
      return;
    }

    if (isChecked) {
      setSelectedStores([...selectedStores, store]);
      return;
    }

    setSelectedStores(selectedStores.filter((selectedStore) => selectedStore.id !== store.id));
  };

  const handleToggleAll = (isChecked) => {
    if (readOnly) {
      return;
    }

    if (isChecked) {
      setSelectedStores(getUniqueStores([...selectedStores, ...selectableStores]));
      return;
    }

    const storeIds = new Set(selectableStores.map((store) => store.id));
    setSelectedStores(selectedStores.filter((selectedStore) => !storeIds.has(selectedStore.id)));
  };

  return (
    <div>
      <FormGroup check style={{ margin: "0 0 20px 0", display: "flex", alignItems: "center", padding: 0 }}>
        <Label check style={{ marginBottom: 0 }}>
          <CustomInput
            type="checkbox"
            id={`store-section-${title}`}
            checked={areAllStoresSelected}
            disabled={readOnly}
            onChange={(e) => handleToggleAll(e.target.checked)}
          />{" "}
        </Label>
        <p
          style={{ fontSize: "14px", margin: 0, padding: "10px 0", cursor: "pointer" }}
          onClick={() => setVisible(!visible)}
        >
          {readOnly
            ? t("releases.store_picker.section.summary.read_only", { title, count: stores.length })
            : t("releases.store_picker.section.summary.editable", { title, total: stores.length, selected: selectedVisibleCount })}
        </p>
      </FormGroup>
      <Collapse isOpen={visible}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {stores.map((store) => (
            <ReleaseStoreCheckboxItem
              key={store.checkboxId || store.id}
              store={store}
              checked={isStoreSelected(store)}
              onChange={handleChange}
              disabled={readOnly}
            />
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default ReleaseStoreSection;
